import React, { Component } from 'react';
import { useAppointmentLabels } from '../../../App/customize/hooks/useAppointmentLabels';
import { useGetFacilityServices } from '../../../App/customize/hooks/useGetFacilityServices';
import moment from 'moment';
import { Card, CardBody, Col } from 'reactstrap';
import { connect } from 'react-redux';

import FindParent from '../../Common/FindParent';
import SelectPet from '../../Common/SelectPet';
import { getParent, clearPetList } from '../../../../redux/actions/petActions';
import {
  createAppointment,
  clearAppointmentStore,
} from '../../../../redux/actions/appointmentAction';
import { clearInviteStore } from '../../../../redux/actions/clientActions';
import MessageModal from '../../../../shared/components/Modals/MessageModal';
import NewAppointmentModal from './NewAppointmentModal';
import withRouter from '../../../../shared/components/withRouter';
import { DEFAULT_TIMESTAMP_FORMAT } from '../../../../constants/constants';
import { routes } from '../../../../constants/routes';

const emptyAppointmentErrors = () => ({
  appointmentDate: null,
  endDate: null,
  time: null,
  appointmentType: null,
  appointmentTypeOther: null,
  doctor: null,
  referringDoctor: null,
});

const emptyResponseBox = () => ({
  showResponse: false,
  responseType: '',
  responseAlertType: '',
  responseFooter: '',
  message: '',
  onSuccess: null,
  appointment: null,
});

const DUPLICATE_APPOINTMENT_SAME_DAY = 'DUPLICATE_APPOINTMENT_SAME_DAY';

function isDuplicateAppointmentSameDayError(error) {
  const text = [
    error?.data?.errorMessage,
    error?.data?.error,
    error?.errorMessage,
    error?.message,
    error?.response?.data?.errorMessage,
    error?.response?.data?.error,
  ]
    .filter(Boolean)
    .join(' ');
  return text.includes(DUPLICATE_APPOINTMENT_SAME_DAY);
}

function duplicateAppointmentSameDayMessage(petName) {
  const name = String(petName || '').trim() || 'This pet';
  return `${name} already has an appointment at your facility on this day.`;
}

const resolveLaunchOrigin = (location) => {
  const state = location?.state || {};
  if (state.launchOrigin) {
    return state.launchOrigin;
  }
  if (state.user?._id) {
    return `/client-list/profile/${state.user._id}`;
  }
  const from = state.from;
  if (typeof from === 'string' && from && from !== '/appointment') {
    return from;
  }
  if (from?.pathname && from.pathname !== '/appointment') {
    return `${from.pathname}${from.search || ''}`;
  }
  return routes.appointments.absolute;
};

class CreateAppointment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isRedirectedFromList: false,
      isFindParentOpen: true,
      petCollapse: false,
      selectedParent: null,
      defaultParent: null,
      selectedPet: '',
      shareUpdates: false,
      appointmentDate: null,
      endDate: null,
      isDaycare: false,
      daycareVisitsCreated: null,
      appointmentTime: null,
      time: '',
      appointmentType: '',
      appointmentTypeOther: '',
      doctor: '',
      referringDoctor: '',
      pet: null,
      errors: emptyAppointmentErrors(),
      responseBox: emptyResponseBox(),
      isCreateOpen: false,
      saveSuccess: false,
      resetParent: false,
      ignoreLaunchParent: false,
      launchOrigin: resolveLaunchOrigin(props.location),
    };

    this.setSelectedParent = this.setSelectedParent.bind(this);
    this.selectPet = this.selectPet.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleShareUpdates = this.handleShareUpdates.bind(this);
    this.handledateChange = this.handledateChange.bind(this);
    this.validate = this.validate.bind(this);
    this.onClose = this.onClose.bind(this);
    this.createAppointment = this.createAppointment.bind(this);
    this.cancel = this.cancel.bind(this);
  }

  componentDidMount() {
    this.props.clearPetList();
    document.addEventListener('keydown', this.handleEscapeLeave, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleEscapeLeave, false);
  }

  UNSAFE_componentWillReceiveProps(np) {
    // Only apply when opened from a client profile (state.user present).
    // Sidebar/global New Appointment also has location.state (e.g. from),
    // but no user — applying that was wiping selectedParent after search
    // select (clearPetList → re-render), which hid the Select Pet panel.
    if (np.location?.state?.user && !this.state.ignoreLaunchParent) {
      this.setState({
        selectedParent: np.location.state.user,
        isRedirectedFromList: true,
        petCollapse: true,
        defaultParent: np.location.state.user,
      });
    }
    const { responseBox, selectedParent, saveSuccess, isDaycare } = this.state;
    // Daycare: NewPetAppointment handles success inline (clear dates, keep
    // modal). Do not treat the first redux CREATE_APPOINTMENT as one-and-done.
    if (
      np.appointments &&
      np.appointments.createAppointment &&
      !saveSuccess &&
      selectedParent &&
      !isDaycare
    ) {
      responseBox.showResponse = true;
      responseBox.responseFooter = true;
      responseBox.responseType = 'alert';
      responseBox.message = 'Appointment successfully created.';
      responseBox.onSuccess = () => {
        this.onClose();
        this.resetToInitialNewAppointment();
      };

      this.setState({
        saveSuccess: true,
        responseBox,
      });

      // Stay on New Appointment — reset to initial state for rapid consecutive creates.
      setTimeout(() => {
        this.onClose();
        this.resetToInitialNewAppointment();
      }, 2500);
    }
if (
  np.appointments?.createAppointmentError &&
  np.appointments.createAppointmentError !==
    this.props.appointments?.createAppointmentError &&
  isDuplicateAppointmentSameDayError(
    np.appointments.createAppointmentError,
  )
) {
  responseBox.showResponse = true;
  responseBox.responseFooter = true;
  responseBox.responseType = 'alert';
  responseBox.message = duplicateAppointmentSameDayMessage(
    this.state.pet?.name,
  );
  responseBox.onSuccess = this.onClose;
  this.setState({ saveSuccess: false, responseBox });
}
    if (np.client.statusUpdated && selectedParent) {
      responseBox.showResponse = true;
      responseBox.responseFooter = true;
      responseBox.responseType = 'alert';
      responseBox.message = `Invitation resent to ${selectedParent.name}`;
      responseBox.onSuccess = this.onClose;
      this.setState({
        saveSuccess: true,
        responseBox,
      });

      setTimeout(() => {
        this.props.history.push('/empty');
        this.props.history.push('/appointments');
      }, 2000);
    }
    if (np.client.statusUpdated && selectedParent) {
      responseBox.showResponse = true;
      responseBox.responseFooter = true;
      responseBox.responseType = 'alert';
      responseBox.message = `Invitation resent to ${selectedParent.name}`;
      responseBox.onSuccess = this.onClose;

      this.setState({ responseBox });
    }
  }

  handleChange(e) {
    const fieldName = e.target.name;
    this.setState({
      [fieldName]: e.target.value,
    });
  }

  selectPet(selectedPet) {
    const { selectedParent } = this.state;
    if (selectedParent) {
      this.setState({
        pet: selectedPet,
        selectedPet: selectedPet ? selectedPet._id : '',
        isCreateOpen: selectedPet !== null,
      });
    }
  }

  setSelectedParent(selectedParent) {
    // null = X clear / reset: drop parent, pet, modal, Select Pet panel.
    // Non-null = parent chosen from search (or profile default).
    this.props.clearPetList();
    this.setState({
      selectedParent: selectedParent || null,
      // Clear defaultParent on reset so FindParent does not re-apply it.
      defaultParent: selectedParent ? this.state.defaultParent : null,
      petCollapse: !!selectedParent,
      selectedPet: '',
      pet: null,
      isCreateOpen: false,
      shareUpdates: false,
      appointmentDate: null,
      endDate: null,
      isDaycare: false,
      daycareVisitsCreated: null,
      appointmentTime: null,
      time: '',
      appointmentType: '',
      appointmentTypeOther: '',
      doctor: '',
      referringDoctor: '',
      errors: emptyAppointmentErrors(),
    });
  }

  // Same reset as search-field X: clear parent/pet and restore Find Parent.
  searchAgain = () => {
    this.setSelectedParent(null);
    this.setState(
      { resetParent: true },
      () => {
        this.setState({ resetParent: false });
      },
    );
  };

  // Focus Find Parent/Pet search without selecting the existing value.
// Empty field (post-reset) → caret at 0. Existing text (Cancel/Esc) → andy|.
focusFindParentSearch = () => {
  window.requestAnimationFrame(() => {
    const el = document.querySelector(
      '.create-appointment .search-wrapper input',
    );
    if (!el || typeof el.focus !== 'function') {
      return;
    }
    el.focus();
    const len = String(el.value || '').length;
    if (typeof el.setSelectionRange === 'function') {
      el.setSelectionRange(len, len);
    }
  });
};

// After successful create: stay on New Appointment, restore initial UI.
resetToInitialNewAppointment = () => {
    this.props.clearPetList();
    this.props.clearAppointmentStore();
    this.props.clearInviteStore();
    this.setState(
      {
        isRedirectedFromList: false,
        selectedParent: null,
        defaultParent: null,
        petCollapse: false,
        selectedPet: '',
        pet: null,
        isCreateOpen: false,
        shareUpdates: false,
        appointmentDate: null,
        endDate: null,
        isDaycare: false,
        daycareVisitsCreated: null,
        appointmentTime: null,
        time: '',
        appointmentType: '',
        appointmentTypeOther: '',
        doctor: '',
        referringDoctor: '',
        errors: emptyAppointmentErrors(),
        responseBox: emptyResponseBox(),
        saveSuccess: false,
        resetParent: true,
        // Prevent location.state.user from re-applying parent after reset.
        ignoreLaunchParent: true,
      },
      () => {
        this.setState({ resetParent: false }, () => {
          this.focusFindParentSearch();
        });
      },
    );
  };

  handleShareUpdates() {
    this.setState({ shareUpdates: !this.state.shareUpdates });
  }

  handledateChange(appointmentDate) {
    this.setState({
      appointmentDate,
      endDate: appointmentDate || null,
    });
  }

  handleEndDateChange = (endDate) => {
    this.setState({ endDate });
  };

  handleTimeChange = (time) => {
    if (time) {
      const appointmentTime = moment(time);
      this.setState({ appointmentTime });
    }
  };

  onChangeSelect = (e, type, resetShareUpdates = false) => {
    const state = this.state;
    if (!e) {
      state[type] = null;
      state.shareUpdates = false;
    } else {
      if (type === 'referringDoctor') {
        state.shareUpdates = !resetShareUpdates;
      }
      state[type] = e.value;
    }

    this.setState(state);
  };

validate() {
  const {
    appointmentDate,
    appointmentTime,
    appointmentType,
    endDate,
    isDaycare,
    errors,
  } = this.state;
  const isBoardingOnly = !!this.props.isBoardingOnly;

  let dateTime = moment(appointmentDate);

  if (appointmentTime) {
    const dt = moment(appointmentDate).format(DEFAULT_TIMESTAMP_FORMAT);
    const apDate = `${dt} ${appointmentTime.format('hh:mm A')}`;

    dateTime = moment(apDate);
  }

  const difference = dateTime.diff(moment.now());
  const differenceInMinutes = moment.duration(difference).asMinutes();

  if (!appointmentDate) {
    errors.appointmentDate = 'Appointment date cannot be empty';
    this.setState({ errors });
    return true;
  }

  if (isBoardingOnly) {
    const selectedDay = moment(appointmentDate).startOf('day');
    if (!selectedDay.isValid()) {
      errors.appointmentDate = 'Appointment date is invalid';
      this.setState({ errors });
      return true;
    }
    if (selectedDay.isBefore(moment().startOf('day'))) {
      errors.appointmentDate = 'Appointment cannot be a past time';
      this.setState({ errors });
      return true;
    }
    errors.appointmentDate = null;
    this.setState({ errors });
  } else if (!dateTime.isValid()) {
    errors.appointmentDate = 'Appointment date is invalid';
    this.setState({ errors });
    return true;
  } else if (
    (differenceInMinutes < -11 && dateTime.minute() > 11) ||
    (difference < 0 && dateTime.minute() > 11) ||
    (differenceInMinutes < -11 && difference < 0)
  ) {
    errors.appointmentDate = 'Appointment cannot be a past time';
    this.setState({ errors });
    return true;
  } else {
    errors.appointmentDate = null;
    this.setState({ errors });
  }

    if (isDaycare && !endDate) {
      errors.endDate = 'End Date is a required field';
      this.setState({ errors });
      return true;
    }

    if (
      isDaycare &&
      moment(endDate).startOf('day').isBefore(moment(appointmentDate).startOf('day'))
    ) {
      errors.endDate = 'End Date cannot be before Stay Date';
      this.setState({ errors });
      return true;
    }

    if (isDaycare) {
      errors.endDate = null;
      this.setState({ errors });
    }

    if (!appointmentTime) {
      errors.time = 'Appointment time cannot be empty';
      this.setState({ errors });
      return true;
    } else {
      errors.time = null;
      this.setState({ errors });
    }

    if (!appointmentType) {
      errors.appointmentType = 'Appointment type cannot be empty';
      this.setState({ errors });
      return true;
    } else {
      errors.appointmentType = null;
      this.setState({ errors });
    }
  }

  async createAppointment() {
    const {
      selectedParent: parentId,
      selectedPet: pet,
      shareUpdates,
      appointmentDate,
      appointmentTime,
      appointmentType: type,
      doctor,
      referringDoctor,
      appointmentTypeOther: typeOther,
      endDate,
      isDaycare,
    } = this.state;

    const basePayload = {
      parentId: parentId._id,
      pet,
      time: appointmentTime.format('hh:mm A'),
      type,
      typeOther: typeOther.trim(),
      doctor: doctor === '' ? null : doctor,
      referringDoctor: referringDoctor === '' ? null : referringDoctor,
      shareUpdates,
    };

    if (isDaycare) {
      const start = moment(appointmentDate).startOf('day');
      const end = moment(endDate).startOf('day');
      const dates = [];
      const current = start.clone();
      while (current.isSameOrBefore(end, 'day')) {
        dates.push(current.clone());
        current.add(1, 'day');
      }

      try {
        for (const date of dates) {
          await this.props.createAppointment({
            ...basePayload,
            appointmentDate: date.format(DEFAULT_TIMESTAMP_FORMAT),
          });
        }

        this.setState({
          appointmentDate: null,
          endDate: null,
          errors: emptyAppointmentErrors(),
          daycareVisitsCreated: dates.length,
        });
        // Prevent leftover CREATE_APPOINTMENT from firing the Boarding reset
        // if the user later switches type without closing the modal.
        this.props.clearAppointmentStore();
        setTimeout(() => {
          this.setState({ daycareVisitsCreated: null });
        }, 2000);
      } catch (error) {
        if (isDuplicateAppointmentSameDayError(error)) {
          const { responseBox } = this.state;
          responseBox.showResponse = true;
          responseBox.responseFooter = true;
          responseBox.responseType = 'alert';
          responseBox.message = duplicateAppointmentSameDayMessage(
            this.state.pet?.name,
          );
          responseBox.onSuccess = this.onClose;
          this.setState({ saveSuccess: false, responseBox });
        }
      }
      return;
    }

    this.onClose();
    this.props.createAppointment({
      ...basePayload,
      appointmentDate: moment(appointmentDate).format(DEFAULT_TIMESTAMP_FORMAT),
    });
  }

  // Esc and Cancel must always perform the same action and always move
  // back exactly one level in the current workflow.
  // Create Appointment open → close create only (keep parent/pet).
  // Initial New Appointment → exit to the screen that launched it.
  cancel() {
    if (this.state.isCreateOpen) {
      this.onCloseAppointmentModal();
      return;
    }
    this.props.clearPetList();
    if (this.props.onCancel) {
      this.props.onCancel();
      return;
    }
    const origin = this.state.launchOrigin || routes.appointments.absolute;
    this.props.history.push(origin);
  }

  handleEscapeLeave = (e) => {
    if (e.key !== 'Escape' && e.keyCode !== 27) {
      return;
    }
    // Don't leave while the success/confirm message modal is showing.
    if (this.state.responseBox?.showResponse) {
      return;
    }
    e.preventDefault();
    // Identical to Cancel — one level only.
    this.cancel();
  };

  getUserData() {
    const { selectedParent, appointmentDate, appointmentTime, pet } =
      this.state;

    return {
      appointmentDate,
      pet: pet.name,
      appointmentTime: moment(appointmentTime, 'HH:mm').format('hh:mm A'),
      parent: `${selectedParent.firstName} ${selectedParent.lastName}`,
    };
  }

  submit = () => {
    if (this.validate()) {
      return;
    }

    this.createAppointment();
  };

  onClose() {
    const { responseBox } = this.state;

    responseBox.showResponse = false;
    responseBox.responseType = '';
    responseBox.responseAlertType = '';
    responseBox.responseFooter = '';
    responseBox.message = '';
    responseBox.appointment = null;

    this.setState({ responseBox });

    this.props.clearInviteStore();
    this.props.clearAppointmentStore();
  }

  // Create Appointment Cancel: close form only; keep parent/pet/search.
  onCloseAppointmentModal = () => {
    this.setState({ isCreateOpen: false }, () => {
      this.focusFindParentSearch();
    });
  };

  onChangeAppointmentType = (event) => {
    const value = event.currentTarget.value;
    const label = (event.currentTarget.selectedOptions[0]?.text || '').trim();
    const isDaycare = label === 'Daycare';

    this.setState((prev) => ({
      appointmentType: value,
      isDaycare,
      endDate: isDaycare ? prev.appointmentDate || null : null,
      daycareVisitsCreated: isDaycare ? prev.daycareVisitsCreated : null,
    }));
  };

  render() {
    const {
      isFindParentOpen,
      selectedParent,
      petCollapse,
      selectedPet,
      appointmentDate,
      appointmentTime,
      time,
      appointmentType,
      doctor,
      referringDoctor,
      shareUpdates,
      errors,
      responseBox,
      isCreateOpen,
      saveSuccess,
      defaultParent,
      endDate,
      isDaycare,
      daycareVisitsCreated,
    } = this.state;

    const content = (
      <>
        {!this.props.noCard && (
          <label className={`heading-text ${saveSuccess && 'highlight-green'}`}>
            {saveSuccess
              ? (this.props.labels?.appointmentSuccessfullyCreated ?? 'Appointment Successfully Created')
              : (this.props.labels?.newAppointment ?? 'New Appointment')}
          </label>
        )}
        <div className="content-wrapper">
          <FindParent
            collapse={isFindParentOpen}
            defaultParent={defaultParent}
            setSelectedParent={this.setSelectedParent}
            reset={this.state.resetParent}
            viewMode={saveSuccess}
            hideSearch={false}
            title={defaultParent ? 'Parent' : 'Find Parent or Pet'}
            history={this.props.history}
          />
          {selectedParent && (
            <SelectPet
              selectedParent={selectedParent}
              collapse={petCollapse}
              selectPet={this.selectPet}
              selectedPet={selectedPet}
              viewMode={saveSuccess}
            />
          )}
        </div>

        {!saveSuccess && (
          <div className="create-appointment-cancel">
            <button
              type="button"
              className="btn loyal-btn-clear"
              onClick={this.cancel}
            >
              Cancel
            </button>
            {selectedParent && (
              <button
                type="button"
                className="btn loyal-btn-save-update"
                style={{ marginLeft: 12 }}
                onClick={this.searchAgain}
              >
                Search Again
              </button>
            )}
          </div>
        )}

        <div className="row">
          <NewAppointmentModal
            isOpen={isCreateOpen}
            petId={selectedPet || undefined}
            reschedule={false}
            createData={{
              shareUpdates,
              appointmentDate,
              appointmentTime,
              time,
              appointmentType,
              endDate,
              isDaycare,
              doctor,
              referringDoctor,
              errors,
              collapse: isCreateOpen,
            }}
            handledateChange={this.handledateChange}
            handleEndDateChange={this.handleEndDateChange}
            handleTimeChange={this.handleTimeChange}
            onChangeSelect={this.onChangeSelect}
            handleShareUpdates={this.handleShareUpdates}
            appointmentDate={this.state.appointmentDate}
            appointmentTime={this.state.appointmentTime}
            viewMode={saveSuccess}
            onClose={this.onCloseAppointmentModal}
            handleChange={this.onChangeAppointmentType}
            submit={this.submit}
            daycareVisitsCreated={daycareVisitsCreated}
          />
        </div>
        {saveSuccess && selectedParent && (
          <div className="row">
            <div className="col-md-12">
              <button
                className="btn loyal-btn-save-update"
                onClick={() => {
                  this.props.history.push({
                    pathname: `client-list/profile/${selectedParent._id}`,
                    activeTab: '3',
                  });
                }}
              >
                {this.props.labels?.viewAppointments ?? 'View Appointments'}
              </button>
            </div>
          </div>
        )}
      </>
    );

    return (
      <>
        <MessageModal
          show={responseBox.showResponse}
          type={responseBox.responseType}
          alertType={responseBox.responseAlertType}
          footer={responseBox.responseFooter}
          onSuccess={responseBox.onSuccess}
          onClose={this.onClose}
          appointment={responseBox.appointment}
          message={responseBox.message}
          returnFocusAfterClose={false}
        />

        <Col md={12} lg={12}>
          {this.props.noCard && (
            <div className="create-appointment create-appointment--new">{content}</div>
          )}
          {!this.props.noCard && (
            <Card>
              <CardBody className="create-appointment create-appointment--new">{content}</CardBody>
            </Card>
          )}
        </Col>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state,
  appointmentCreated: state.appointments.createAppointment,
  appointmentCreateError: state.appointments.createAppointmentError,
});

const mapDispatchToProps = {
  getParent,
  createAppointment,
  clearInviteStore,
  clearAppointmentStore,
  clearPetList,
};

function CreateAppointmentWithLabels(props) {
  const labels = useAppointmentLabels();
  const { data: services } = useGetFacilityServices();
  return (
    <CreateAppointment
      {...props}
      labels={labels}
      isBoardingOnly={!!services?.isBoardingOnly}
    />
  );
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CreateAppointmentWithLabels),
);
